import React from 'react'
import "./Payment.css"
function PaymentHistory() {
    const paymentHistory = [
        {
          desktopName: 'Desktop-01',
          date: '2023-04-15',
          mac:"555545544",
          amount: 99.99,
          paymentStatus: 'Paid',
          modeOfPayment: 'Credit Card',
          createdByUser: 'John Doe',
        },
        {
          desktopName: 'Desktop-02',
          mac:"555545544",
          date: '2023-03-22',
          amount: 149.99,
          paymentStatus: 'Unpaid',
          modeOfPayment: 'PayPal',
          createdByUser: 'Jane Smith',
        },
        // Add more payment history data as needed
      ];
  return (
    <div>
 
      <table className='table table-responsive table-striped'>
        <thead>
          <tr>
            <th>Desktop Name</th>
            <th>Date</th>
            <th>Amount</th>
            <th>Payment Status</th>
            <th>Mode of Payment</th>
            <th>Created By User</th>
          </tr>
        </thead>
        <tbody>
          {paymentHistory.map((payment, index) => (
            <tr key={index}>
              <td data-label="Desktop Name">{payment.desktopName}</td>
              <td data-label="Date">{payment.date}</td>
              <td data-label="Amount">${payment.amount.toFixed(2)}</td>
              <td  data-label="Payment Status"
              >
                
              <span className={payment.paymentStatus === "Paid" ? "payment-status dot-active" : "payment-status dot-block"}>{payment.paymentStatus}</span>
              </td>
              <td data-label="Mode of Payment">{payment.modeOfPayment }</td>
              <td data-label="Created By User">{payment.createdByUser}</td>
            </tr>
          ))}
        </tbody>
      </table>

    </div>
  )
}

export default PaymentHistory
